<template>
  <div class="settings-page-block i-py-14 i-section-divide i-mt-14">
    <div class="settings-page-block-title">
      <h5 class="i-text-heading-5 i-text-neutral-120 i-mb-0">
        Authentication Requirements
      </h5>
      <p class="i-text-body-2 i-text-neutral-110">
        Choose whether to enforce SSO for all users
      </p>
    </div>

    <div class="settings-page-block-content">
      <!-- Warning message when strict mode is enabled -->
      <div
        v-if="showWarning"
        class="i-mb-10 i-p-8 i-bg-neutral-20 i-radius-3xl"
      >
        <div class="d-flex align-items-center">
          <i-icon
            symbol="small-solid-info"
            class="i-mr-3 i-text-neutral-110"
            :size="16"
          ></i-icon>
          <span class="i-text-body-2 i-text-neutral-110">
            All users will be prevented from logging in with email and password.
          </span>
        </div>
      </div>

      <i-radio
        :options="authenticationOptions"
        :default-value="strictMode.toString()"
        @option-selected="setAuthenticationPreference"
      ></i-radio>

      <i-button
        text="Update"
        type="primary"
        size="lg"
        class="i-mt-10"
        :disabled="!hasChanges"
        @button-click="updateAuthenticationSettings"
      ></i-button>
    </div>
  </div>
</template>

<script>
import { $event } from '@/bus';
import { iButton, iIcon, iRadio, showToast } from '@inscribe/signal';

export default {
  components: {
    'i-button': iButton,
    'i-icon': iIcon,
    'i-radio': iRadio,
  },
  data() {
    return {
      strictMode: false,
      originalStrictMode: false,
      authenticationOptions: [
        {
          value: 'false',
          title: 'Allow password-based authentication',
          subtitle: 'Users can log in with email and password',
        },
        {
          value: 'true',
          title: 'Disable password-based authentication',
          subtitle: 'Users can only log in via Single Sign-On',
        },
      ],
    };
  },
  computed: {
    hasChanges() {
      return this.strictMode !== this.originalStrictMode;
    },
    showWarning() {
      return !this.originalStrictMode && this.strictMode;
    },
  },
  mounted() {
    this.loadSsoConfig();
  },
  methods: {
    setAuthenticationPreference(preference) {
      this.strictMode = preference === 'true';
    },
    async updateAuthenticationSettings() {
      $event.$emit('preloader.on');
      try {
        await this.$store.dispatch('updateSsoConfig', {
          strict_mode: this.strictMode,
        });
        this.originalStrictMode = this.strictMode;
        showToast({
          text: 'Authentication settings updated successfully',
        });
      } catch (error) {
        showToast({
          text: 'Failed to update authentication settings. Please try again.',
          isError: true,
        });
      } finally {
        $event.$emit('preloader.off');
      }
    },
    async loadSsoConfig() {
      try {
        const response = await this.$store.dispatch('getSsoConfig');
        this.strictMode = Boolean(response.data?.strict_mode);
        this.originalStrictMode = this.strictMode;
      } catch (error) {
        this.strictMode = false;
        this.originalStrictMode = false;
      }
    },
  },
};
</script>
